import { create } from "zustand";
import { persist } from "zustand/middleware";

type Mode = "light" | "dark" | "system";

export const useThemeStore = create<{ mode: Mode; setMode: (m: Mode) => void }>()(
  persist((set) => ({ mode: "system", setMode: (mode) => set({ mode }) }),
    { name: "shitamy.contractor.theme" }),
);
